import { Get_Otp_List_POST } from 'api/ApiConst';
import PaginationDataTable from 'components/common/PaginationDataTable';
import React, { useCallback, useMemo, useState } from 'react'
import dateUtilities from 'utils/DateUtilities';

const OtpMaster = () => {
    const [refreshFlag, setRefreshFlag] = useState(0)
    const [viewDeletedList, setViewDeletedList] = useState(false);

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
      }, [refreshFlag]);

    const columns = useMemo(
        () => [
          {
            id: "expiry_Date",
            name: "Expiry Date",
            selector: (row) => dateUtilities.formattedDate(row.expiredAt, "dd-MM-yyyy hh:mm aa"),
          },
          {
            id: "code",
            name: "Code",
            cell: (row) => row.otpCode,
          },
          {
            id: "sent_on",
            name: "Sent On",
            selector: (row) => row.sentOn,
          },
          {
            id: "mobile",
            name: "Sent On Mobile/Email",
            selector: (row) => row.sentOnEmailMobile,
          },
          {
            id: "verification_type",
            name: "Verification Type",
            selector: (row) => row.verificationType,
          }
        ],
        [handleRefresh]
      );

  return (
    <>
      <div className="container-fluid">
        <div className="card shadow mt-3">
          <div className="text-end p-3 border-bottom d-flex align-content-center justify-content-between ">
            <div className="page-title-box ">
              <h4 className="mb-sm-0 font-size-18">Otp List</h4>
            </div>
            {/* <div>
              {!viewDeletedList && (
                <button
                  className="btn btn-primary me-3"
                  onClick={() => handleAddEvent()}
                >
                  Add
                </button>
              )}

              <div className="btn form-check btn-primary">
                <input
                  className="form-check-input ms-0"
                  type="checkbox"
                  onChange={() => setViewDeletedList(!viewDeletedList)}
                  id="flexCheckDefault"
                />
                <label
                  className="form-check-label text-light ps-2"
                  htmlFor="flexCheckDefault"
                >
                  Delete List
                </label>
              </div>
            </div> */}
          </div>
          <PaginationDataTable
            paginationUrl={Get_Otp_List_POST}
            serverSidePagination={true}
            search={true}
            pagination={false}
            columns={columns}
          />
        </div>
      </div>
</>
  )
}

export default OtpMaster